import { convertToNewLine } from '../../core/helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function NoTagRenderer({ children }: any) {
  return convertToNewLine(children);
}

export default NoTagRenderer;
